import { isNonTestDev } from "utilities/src/environment/constants";
import { logger } from "utilities/src/logger/logger";
export function generateAnalyticsLoggers(fileName) {
  return {
    init(error) {
      logger.error(error, { tags: { file: fileName, function: "init" } });
    },
    sendEvent(eventName, eventProperties) {
      if (isNonTestDev) {
        logger.info("analytics", "sendEvent", `[Event: ${eventName}]`, eventProperties ?? {});
      }
    },
    setAllowAnalytics(allow) {
      if (isNonTestDev) {
        logger.info("analytics", "setAnonymous", `user allows analytics: ${allow}`);
      }
    },
    flushEvents() {
      if (isNonTestDev) {
        logger.info("analytics", "flushEvents", "flushing analytics events");
      }
    },
    setUserProperty(property, value) {
      if (isNonTestDev) {
        logger.info("analytics", "setUserProperty", `[Property: ${property}]: ${value}`);
      }
    }
  };
}
